// removed by extract-text-webpack-plugin
module.exports = {"productNameText":"productNameText__1xknu","productText":"productText__18aot","productSliderContainer":"productSliderContainer__6aa65","productDetailsContainer":"productDetailsContainer__1Cnyb","outerProductDetailsContainer":"outerProductDetailsContainer__2yDr7","shopNowText":"shopNowText__JpgB_","productIcon":"productIcon__1qy_t"};


//////////////////
// WEBPACK FOOTER
// ./routes/generic-campaign-success/components/campaignLandingProductSection/productSlider/style.css
// module id = hV/n
// module chunks = 458